// ResetPassword
import { ResetPassword } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Password setup');
      },
      // title: () => t('login'),
      //   class: 'w-[860px] h-[700px]'
    },
  },
};

export default ResetPassword;
